const MIN_PAGE = 1
const MAX_PAGE = 40
/** Hard cap on opportunity lines per packed customer page. */
export const MAX_CUSTOMER_PAGE_LINES = 20
/** Reserve a couple of rows for group header/footer chrome when estimating. */
const GROUP_CHROME_RESERVE = 2

/** Ignore sub-threshold reflows (group chrome, thead wrap) that thrash pageSize. */
export const FIT_RESIZE_WIDTH_PX = 24
export const FIT_RESIZE_HEIGHT_PX = 32

export function capacityForPane(opts: {
  paneHeight: number
  headerHeight: number
  rowHeight: number
  customerGrouped: boolean
}): number {
  const rowHeight = Math.max(opts.rowHeight, 1)
  const bodyBudget = Math.max(0, opts.paneHeight - opts.headerHeight - 8)
  const rowsFit = Math.max(1, Math.floor(bodyBudget / rowHeight))
  if (opts.customerGrouped) {
    // Line budget for packing whole customers (not a fixed customers-per-page count).
    const lineBudget = Math.max(1, rowsFit - GROUP_CHROME_RESERVE)
    return Math.min(MAX_CUSTOMER_PAGE_LINES, Math.max(MIN_PAGE, lineBudget))
  }
  return Math.min(MAX_PAGE, Math.max(MIN_PAGE, rowsFit))
}

export function shouldAcceptFitResize(args: {
  prev: { w: number; h: number }
  next: { w: number; h: number }
}): boolean {
  const { prev, next } = args
  if (prev.h === 0 || prev.w === 0) return true
  return (
    Math.abs(prev.w - next.w) > FIT_RESIZE_WIDTH_PX ||
    Math.abs(prev.h - next.h) > FIT_RESIZE_HEIGHT_PX
  )
}

export { MIN_PAGE, MAX_PAGE }
